import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Dropdown, type MenuProps } from 'antd';
import type React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import avatarPlaceholder from '@/assets/images/memoji/memoji-1.png';
import { IntlMessages } from '@/components';
import { logOut, selectUserData } from '@/domains/Auth/features/authSlice';
import appRoutes from '@/configs/routes';
import styles from './HeaderUser.module.css';

const HeaderUser: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user: profile } = useSelector(selectUserData);

  const signOut = () => {
    dispatch(logOut());
  };

  const items: MenuProps['items'] = [
    {
      key: 1,
      label: <IntlMessages id="layout-header-profile-card-title" />,
      disabled: true,
    },
    {
      key: 2,
      label: <IntlMessages id="layout-header-profile-card-view-profile" />,
      icon: <UserOutlined />,
      onClick: () => navigate(appRoutes.urlPageProfile),
    },
    {
      type: 'divider',
    },
    {
      key: 3,
      label: <IntlMessages id="ui-general-logout" />,
      icon: <LogoutOutlined />,
      onClick: () => signOut(),
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={['click', 'hover']} placement="bottomLeft" rootClassName={styles.rootWrapper}>
      <img src={profile?.avatar ?? avatarPlaceholder} alt="User" className={styles.avatar} />
    </Dropdown>
  );
};

export default HeaderUser;
